import { CommonModule } from '@angular/common';
import { Component, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChimieService } from '../../../services/chimie.service';

@Component({
  selector: 'app-creer-chimie',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './creer-chimie.component.html',
  styleUrl: './creer-chimie.component.scss'
})
export class CreerChimieComponent {
  nom = '';
  error = '';
  success = '';
  loading = false;

  constructor(
    private readonly chimieService: ChimieService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  create(): void {
    this.error = '';
    this.success = '';
    this.loading = true;
    this.chimieService.create({ nom: this.nom }).subscribe({
      next: () => {
        this.success = 'Chimie créée.';
        this.nom = '';
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.error = 'Erreur lors de la création.';
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }
}
